<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
      <h3>{{ company.name }}</h3>

      <ul class="text-small list-unstyled">
        <li>
          <span>{{ $t('Adresse') }}:</span>
          {{ company.street }}<br />
          <span></span> {{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span>Phone:</span>
          <a :href="'tel:' + company.phone">
              {{ company.phone }}
          </a>
        </li>

        <li>
          <span>E-Mail:</span>
          <a :href="'mailto:' + company.email">
            {{ $t('E-Mail senden') }}</a>
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <h3>{{ $t('Ihr Weg zu uns') }}</h3>

        <p class="text-small">
          {{ $t('Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.') }}
        </p>

        <p>
          <a :href="'https://www.google.de/maps?daddr=' + company.street + ', ' + company.zip + '+' + company.city + '&saddr='"
             :title="$t('Route jetzt berechnen')"
             target="_blank"
             class="link--arrow">
              {{ $t('Route jetzt berechnen') }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
